import { AddIcon } from '@chakra-ui/icons';
import { Container, Flex, Text } from '@chakra-ui/react';
import { Checkbox, DatePicker, DateRangeWithInput, Select, SwitchableInput, Tabs } from 'components';
import { Button } from 'components/Button';
import { useGetAirports } from 'hooks';
import { useState } from 'react';
import { AIRPLANE_CLASSES, TRAVELERS_NUMBERS } from 'utils';

type DestinationFilterProps = {
    onChange: (values: any) => void;
    activeFilter: boolean;
};

const AIRPLANE_FILTERS = {
    TRAVELERS: 'travelers',
    CLASS: 'class',
    NON_STOP: 'non_stop',
    NEARBY_AIRPORTS: 'nearby_airports',
    LEAVING_FROM: 'leaving_from',
    GOING_TO: 'going_to',
    DEPART: 'depart',
    RETURN: 'return'
};

const AirplaneFilter = ({onChange, activeFilter}: DestinationFilterProps) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [filters, setFilters] = useState({});
    const { data: responseData } = useGetAirports();
    const mappedResponse = responseData?.data.map((airport: { id: any; airportName: any; }) => ({value: airport.id, label: airport.airportName}));
    const [multiCities, setMultiCities] = useState([{
        key: 1
    },
    {
        key: 2
    }])
    const departDate = 
        <DateRangeWithInput
        tabChanged={activeFilter}
        onChange={(dates) => setFilters({ [AIRPLANE_FILTERS.DEPART]: dates.startDate, [AIRPLANE_FILTERS.RETURN]: dates.endDate })}
        placeholder='Depart - Return' />

    const leavingFromInputProps = 
        {   
            options: mappedResponse,
            placeholder: 'Leaving from',
            onChange: (event: any) =>  setFilters({[AIRPLANE_FILTERS.LEAVING_FROM]: event.target.value})
        };

     const  goingToInputProps=  {
            options: mappedResponse,
            placeholder: 'Going to',
            onChange: (event: any) =>  setFilters({[AIRPLANE_FILTERS.GOING_TO]: event.target.value})
        };

    const destinationsTabContent =
        <Flex  padding={0} justifyContent="flex-start" flexDirection="column" marginBottom={10} width={900}>
            <SwitchableInput inputsProps={[leavingFromInputProps, goingToInputProps]} />
        </Flex>

    const selectsTabContent =
        <Flex justifyContent="flex-start" flexDirection="row" width={300} marginBottom={10}>
            <Container  padding={0} width={150}>
                <Select onChange={(event) => setFilters({[AIRPLANE_FILTERS.TRAVELERS]: event})} options={TRAVELERS_NUMBERS} />
            </Container>
            <Container padding={0} width={150}>
                <Select onChange={(event) => setFilters({[AIRPLANE_FILTERS.CLASS]: event})}  options={AIRPLANE_CLASSES} />
            </Container>
        </Flex>

    const checkboxesTabContent =
        <Flex justifyContent="flex-start" flexDirection="column" width={200}>
            <Checkbox onChange={(event) => setFilters({[AIRPLANE_FILTERS.NON_STOP]: event.target.value})} label="Non - stop flights only"/>
            <Checkbox onChange={(event) => setFilters({[AIRPLANE_FILTERS.NEARBY_AIRPORTS]: event.target.value})} label="Add nearby airports" />
        </Flex>

    const tabList = [{
        id: 1,
        title: 'Roundtrip',
        content: <Container  maxWidth="100%" padding={10}>
                    {selectsTabContent}
                    <Flex flexDirection="row" justifyContent="space-between">
                        {destinationsTabContent}
                        {departDate}
                    </Flex>
                    {checkboxesTabContent}
                </Container>
    },
    {
        id: 2,
        title: 'One-way',
        content:<Container  maxWidth="100%" padding={10}>
                    {selectsTabContent}
                    <Flex flexDirection="row" justifyContent="space-between">
                        {destinationsTabContent}
                        <DatePicker placeholder='Depart' onChange={(dates) => setFilters({ [AIRPLANE_FILTERS.DEPART]: dates.startDate, [AIRPLANE_FILTERS.RETURN]: dates.startDate })} tabChanged={false} />
                    </Flex>
                    {checkboxesTabContent}
                </Container>
    },
    {
        id: 2,
        title: 'Multi-city',
        content:<Container  maxWidth="100%" padding={5}>
            {multiCities.map((city) => <>
            <Text paddingBottom="40px" paddingTop="40px" fontSize="26px" fontWeight={700} fontFamily="Montserrat"> Flight {city.key} </Text>
                {selectsTabContent}
                <Flex flexDirection="row" justifyContent="space-between">
                    {destinationsTabContent}
                    {departDate}
                </Flex>
                {checkboxesTabContent}
            </>
            )}
            <Flex paddingTop={5}>
                <Button
                variant='outline'
                size='lg'
                colorScheme='blue'
                icon={<AddIcon />}
                label="Add another flight"
                onClick={() => setMultiCities([...multiCities, {key: multiCities.length+1}])} />
            </Flex>
    </Container>
    }];

    return <Container paddingTop={5} paddingBottom={5} marginLeft={0} marginRight={0} maxWidth="100%" height="fit-content">
    <Tabs onChange={() => setFilters({})} alignment="flex-start" variant='line' unstyled tabList={tabList} />
    </Container>
}

export {AirplaneFilter};